const paths = {
  home: '/',
  accountantHome: '/accountant/dashboard',
  accountantCompany: '/accountant/company',
  login: '/login',
  account: '/account',
  invoices: '/invoices',
  lawyerLawsuits: '/lawyer/lawsuits',
  lawsuitCircumstances: '/lawsuits/new/circumstances',
  lawsuits: '/lawsuits',
  accountDeleted: '/account-deleted',
  subscription: '/subscription',
  subscriptionSummary: '/subscription/summary',
  subscriptionPayment: '/subscription/payment',
  resetPassword: '/reset-password',
  confirm: '/confirm',
}

export default paths
